import {fabric} from 'fabric'
export function makeImage(canvas) {
    let imgObj = new Image();
    imgObj.src = "https://tineye.com/images/widgets/mona.jpg";
    imgObj.onload = function ()
    {
        let image = new fabric.Image(imgObj);
        image.set({
            angle: 0,
            padding: 0,
            left:100,
            top:100,
            originX: "center",
            originY: "center"
        });
        canvas.add(image);

    }

}